import React, { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useUser } from "../../UserContext";

const ImageAcquisition = () => {
    const navigate = useNavigate();
    const { topicId, courseId } = useParams();
    const location = useLocation();

    // Retrieve registration_id from the location state
    const registrationId   = location.state?.registration_id || "";
    const reportId         = location.state?.reportId       || "";
    const assignmentId     = location.state?.assignmentId;
    const teacher_username = location.state?.teacher_username;
    const { user }         = useUser();
     useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    useEffect(() => {
        console.log('🚀 Passed teacherusername:', teacher_username);
    }, [teacher_username]);

    const handleNext = () => {
        console.log("Navigating to internal image-analysis route");
        navigate(
            `/student-dashboard/courses/ongoing/${topicId}/protocols/image-analysis/${courseId}`,
            { state: { registration_id: registrationId, reportId, assignmentId, teacher_username } }
        );
    };

    // const handleSimulator = () => {
    //     console.log("Opening external simulator URL in a new tab");
    //     window.open("http://43.205.75.103:8080/", "_blank", "noopener,noreferrer");
    // };

    return (
        <div className="relative flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center shadow-md">
                    <span className="text-xl text-white">📷</span>
                </span>
                <span className="bg-gradient-to-r from-blue-700 to-blue-500 text-transparent bg-clip-text">
                    CT Image Acquisition Guide
                </span>
            </h1>

            {/* Steps Section */}
            <div className="w-full max-w-4xl bg-white rounded-xl shadow-lg p-8 mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
                    <span className="bg-blue-100 text-blue-700 rounded-full w-8 h-8 flex items-center justify-center mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                    </span>
                    Acquisition Process Guide
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        <p className="font-medium text-blue-800">Step 1: Login to the System</p>
                        <p className="text-sm text-gray-600">Ensure the student logs into the workstation using their assigned credentials.</p>
                    </div>
                    
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        <p className="font-medium text-blue-800">Step 2: Navigate to the CT Scan Simulator</p>
                        <p className="text-sm text-gray-600">Open the application on the master workstation and verify all components are functioning.</p>
                    </div>
                    
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        <p className="font-medium text-blue-800">Step 3: Enter Patient Details</p>
                        <p className="text-sm text-gray-600">UserId: {user.id} <br />ID: {registrationId}</p>
                    </div>
                    
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        <p className="font-medium text-blue-800">Step 4: Select Scan Protocol</p>
                        <p className="text-sm text-gray-600">Choose the appropriate protocol based on examination requirements.</p>
                    </div>
                    
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        <p className="font-medium text-blue-800">Step 5: Position the Patient</p>
                        <p className="text-sm text-gray-600">Verify proper positioning in the gantry with laser guidance.</p>
                    </div>
                    
                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                        <p className="font-medium text-blue-800">Step 6: Acquire Images</p>
                        <p className="text-sm text-gray-600">Initiate the scan sequence and monitor the process.</p>
                    </div>
                </div>
            </div>

            {/* Buttons Section */}
            <div className="w-full max-w-4xl flex justify-center space-x-4">
                <button
                    onClick={handleNext}
                    className="px-8 py-3 bg-blue-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-700 transition-all flex items-center gap-2"
                >
                    Next
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20                                                                                 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6                                                                                 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"                                                                 clipRule="evenodd" />
                    </svg>
                </button>

                {/* New Button: Open External Simulator */}
                {/* <button
                    onClick={handleSimulator}
                    className="px-8 py-3 bg-green-600 text-white text-lg font-semibold rounded-lg shadow-md                                                                 hover:bg-green-700 transition-all flex items-center gap-2"
                >
                    Open Simulator
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5"                                                                                 viewBox="0 0 20 20" fill="currentColor">
                        <path d="M3 10a1 1 0 011-1h8a1 1 0 110 2H4a1 1 0 01-1-1z" />
                    </svg>
                </button> */}
            </div>
        </div>
    );
};

export default ImageAcquisition;
